import clsx from 'clsx';

import type { DetailedHTMLProps, LiHTMLAttributes, ReactNode } from 'react';

import s from './ListItem.module.css';

type Props = DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement> & {
  marker?: ReactNode;
};

export const ListItem = ({ children, className, marker, ...props }: Props) => (
  <li className={clsx(s.listItem, className)} {...props}>
    {marker}

    {children}
  </li>
);
